// src/components/Leaderboard/Leaderboard.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Card,
  CardActionArea,
  CardContent,
  Avatar,
  Typography,
  CircularProgress,
  Stack,
  Divider
} from '@mui/material';
import API from '../config';

export default function Leaderboard() {
  const [creators, setCreators] = useState([]);
  const [error, setError]       = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const resp = await axios.get(`${API}/api/leaderboard`);
        setCreators(resp.data.leaderboard || []);
      } catch (err) {
        console.error(err);
        setError('Failed to load leaderboard.');
      } finally {
        setLoading(false);
      }
    };
    fetchLeaderboard();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display:'flex', justifyContent:'center', mt:4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" align="center" sx={{ mt:4 }}>
        {error}
      </Typography>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py:8 }}>
      <Typography variant="h4" component="h2" gutterBottom align="center">
        Top Creators
      </Typography>
      <Divider sx={{ mb:3 }} />

      <Stack spacing={2}>
        {creators.map((c, idx) => (
          <Card key={c.id} elevation={2} sx={{ width:'100%' }}>
            <CardActionArea
              component={RouterLink}
              to={`/creator/${c.id}`}
              sx={{ display:'flex', alignItems:'center', p:2 }}
            >
              <Typography
                variant="h5"
                sx={{ width: '3ch', textAlign:'center', mr:2 }}
              >
                {idx+1}
              </Typography>

              <Avatar
                src={c.profilePicture || '/default-profile.png'}
                alt={c.username}
                sx={{ width:64, height:64, mr:2 }}
              />

              <CardContent sx={{ flex:'1 1 auto', py:0 }}>
                <Typography variant="h6">{c.username}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Avg Quality: {c.averageQuality.toFixed(1)} / 5
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Reviews: {c.numReviews}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Score: {c.score.toFixed(2)}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>
    </Container>
  );
}
